import { KompisDefaultFields } from '@inter-ikea-kompis/services';
import { IProduct } from '@inter-ikea-kompis/types';
import { getProductService } from '../../services/ServiceHandler';
import { Thunk } from '../../generalTypes';
import { actionSetYmalData } from './ymalActions';
import { selectYmalCmsObjects } from './ymalSelectors';

/**
 * Thunk store YMALs
 * @param inYMALs
 */
export const thunkStoreYMALs: Thunk<any> = inYMALs => async dispatch => {
  const ymalProductsFromKompis: IProduct[] =
    await getProductService().getProducts(inYMALs, KompisDefaultFields);
  const validYMALs = ymalProductsFromKompis.filter(
    product => product.content && product.valid
  );

  dispatch(actionSetYmalData(validYMALs));
};

/**
 * Build YMALs
 */
export const thunkBuildYMALs: Thunk = () => (dispatch, getState) => {
  const YMALs = selectYmalCmsObjects(getState());
  dispatch(thunkStoreYMALs(YMALs));
};
